import api from "../api";
import {ElMessage} from "element-plus";

export default {
    namespaced: true,
    state: {
        loading: false,
        users: {data: [], current_page: 1, total: 0, per_page: 10},
        user_roles: {data: [], current_page: 1, total: 0, per_page: 10},
        user_permissions: {data: []},
        user: null,
        authorization_error: null,
        two_factor: null,
        blocked_user_id: null,
        errors: {
            data: {
                errors: {
                    first_name: [],
                    last_name: [],
                    email: [],
                    login: [],
                    password: [],
                    status: [],
                    captcha: [],
                    gender_id: [],
                    otp: [],
                }
            }
        },
        has_errors: false,
        authenticating: false,
        dialogVisible: false,

    },
    getters: {
        dialogVisible: state => state.dialogVisible,
        user: state => state.user === null ? JSON.parse(localStorage.getItem('user')) : state.user,
        errors: state => state.errors,
        two_factor: state => state.two_factor,
        blocked_user_id: state => state.blocked_user_id,
        has_errors: state => state.has_errors,
        authenticating: state => state.authenticating,
        authorization_error: state => state.authorization_error,
        users: state => state.users,
        user_roles: state => state.user_roles,
        user_permissions: state => state.user_permissions,
        loading: state => state.loading
    },
    mutations: {

        setLoading(state, val) {
            state.loading = val
        },
        set2FA(state, val) {
            state.two_factor = val
        },
        setBlockedUserId(state, val) {
            state.blocked_user_id = val
        },
        setDialogVisible(state, status) {
            state.dialogVisible = status;
        },
        authenticating(state, val) {
            state.authenticating = val
        },
        setUserPermissions(state, data) {
            state.user_permissions = data;
        },
        setUserRoles(state, data) {
            state.user_roles = data;
        },
        setUsers(state, data) {
            state.users = data;
        },
        setUser(state, user) {
            state.user = user;
        },
        setErrors(state, errors) {
            state.errors = errors
        },
        setAuthorizationError(state, val) {
            state.authorization_error = val
        },
        hasErrors(state, val) {
            state.has_errors = val
            if (!val) {
                // no errors
                state.errors = {
                    data: {
                        errors: {
                            first_name: [],
                            last_name: [],
                            email: [],
                            login: [],
                            password: [],
                            status: [],
                            captcha: [],
                            gender_id: [],
                            otp: [],
                        }
                    }
                };
            }
        }
    },
    actions: {
        async authenticate2FA({commit}, credentials) {
            try {
                commit('authenticating', true)
                commit('hasErrors', false)
                const response = await api.verify2FA(credentials);
                await localStorage.setItem('app_token', response?.user?.token);
                await localStorage.setItem('user', JSON.stringify(response?.user));
                commit('authenticating', false)
                commit('setUser', response.user);
                window.location.href = '/dashboard'
            } catch (e) {
                commit('authenticating', false)
                let status = e.response.status
                if (status === 401) {
                    commit('setAuthorizationError', e.response?.data.message)
                }
                if (status === 422) {
                    commit('hasErrors', true)
                    commit('setErrors', e.response)
                    commit('setAuthorizationError', 'Please correct the errors below')
                }
                if (status === 429) {
                    commit('setAuthorizationError', e.response?.data.message)
                }
            }
        },
        async authenticate({commit}, credentials) {
            try {
                commit('authenticating', true)
                commit('hasErrors', false)
                commit('setBlockedUserId', null)
                const response = await api.login(credentials);
                console.log("Response", response)
                await localStorage.setItem('app_token', response?.user?.token);
                await localStorage.setItem('user', JSON.stringify(response?.user));
                commit('authenticating', false)
                commit('set2FA', response.user_id);
                // window.location.href = '/dashboard'
            } catch (e) {
                commit('authenticating', false)
                let status = e.response.status
                if (status === 401) {
                    commit('setAuthorizationError', e.response.data.message)
                    if (e.response.data.blocked) {
                        commit('setBlockedUserId', e.response.data.user_id)
                    }
                }
                if (status === 422) {
                    commit('hasErrors', true)
                    commit('setErrors', e.response)
                    commit('setAuthorizationError', 'Please correct the errors below')
                }
                if (status === 429) {
                    commit('setAuthorizationError', e.response.data.message)
                }
            }
        },
        async authenticateByHash({commit}, credentials) {
            try {
                commit('authenticating', true)
                commit('hasErrors', false)
                const response = await api.loginByHash(credentials);
                await localStorage.setItem('app_token', response.token);
                await localStorage.setItem('user', JSON.stringify(response.user))
                commit('authenticating', false)
                commit('set2FA', response.user_id);
                // commit('setUser', response.user);
                // window.location.href = '/dashboard'
            } catch (e) {
                commit('authenticating', false)
                let status = e.response.status
                if (status === 401) {
                    commit('setAuthorizationError', e.response.data.message)
                }
                if (status === 422) {
                    commit('hasErrors', true)
                    commit('setErrors', e.response)
                    commit('setAuthorizationError', 'Please correct the errors below')
                }
            }
        },

        async logout(context, filters = {}) {
            await api.logout(filters);
            localStorage.removeItem('app_token');
            localStorage.removeItem('user_id');
            localStorage.removeItem('user');
            localStorage.removeItem('tenant');
            window.location.href = '/login';
        },
        async getUsers({commit}, filters) {
            try {
                commit('setLoading', true)
                commit('activateLoading', 'user/list', {root: true});
                const response = await api.getUsers(filters);
                commit('setUsers', response);
                commit('setLoading', false)
                commit('deactivateLoading', 'user/list', {root: true});
            } catch (e) {
                commit('setLoading', false)
                commit('deactivateLoading', 'user/list', {root: true});
                ElMessage.error(e.response.data.message);
            }
        },
        async registerUser({commit}, data) {
            try {
                commit('setLoading', true)
                commit('authenticating', true)
                commit('hasErrors', false)
                const response = await api.registerUser(data);
                commit('authenticating', false)
                await localStorage.setItem('user_id', response?.user?.id);
                await localStorage.setItem('user', JSON.stringify(response.user))
                window.location.href = '/verify-account'
                ElMessage.success({
                    message: 'Your account has been created successfully.'
                })
                commit('setLoading', false)
            } catch (e) {
                commit('authenticating', false)
                commit('hasErrors', true)
                commit('setErrors', e.response)
                ElMessage.error({
                    message: 'There was a problem creating your account. Please try again later.'
                })
                commit('setLoading', false)
            }
        },

        async verifyUser({dispatch, commit}, data) {
            try {
                commit('setLoading', true)
                commit('hasErrors', false)
                const response = await api.verifyUser(data);
                commit('setLoading', false)
                await localStorage.setItem('profile_hash', response?.user?.profile_hash);
                ElMessage.success({
                    message: 'Your account has been verified successfully.'
                })
                commit("setLoading", false)
                window.location.href = '/onboarding/' + response?.user?.onboarding_hash
            } catch (e) {
                commit('setLoading', false)
                commit('hasErrors', true)
                commit('setErrors', e.response)
                ElMessage.error({
                    message: 'There was a problem verifying your account.'
                })
                commit('setLoading', false)
            }
        },
        // Same /verify-account endpoint as verifyUser above, but for
        // ResetPassword.vue's caller instead of VerifyAccount.vue's -
        // a PM resetting a forgotten password isn't onboarding, so unlike
        // verifyUser this doesn't redirect to /onboarding/{hash}. Left as
        // its own action rather than branching verifyUser on a flag, so
        // each caller's redirect stays obvious from its own action name.
        async completePasswordReset({commit}, data) {
            try {
                commit('setLoading', true)
                commit('hasErrors', false)
                await api.verifyUser(data);
                commit('setLoading', false)
                ElMessage.success({
                    message: 'Your password has been reset successfully.'
                })
            } catch (e) {
                commit('setLoading', false)
                commit('hasErrors', true)
                commit('setErrors', e.response)
                ElMessage.error({
                    message: 'There was a problem resetting your password.'
                })
            }
        },
        async verifyOtp({dispatch, commit}, data) {
            try {
                commit('authenticating', true)
                commit('hasErrors', false)
                const response = await api.verifyOtp(data);
                commit('authenticating', false)
                await localStorage.setItem('app_token', response.token);
                window.location.href = '/reset'
                ElMessage.success({
                    message: 'Code entered successfully!',
                    duration: 10000
                });
            } catch (e) {

                commit('authenticating', false)
                commit('hasErrors', true)
                commit('setErrors', e.response)
                ElMessage.error({
                    message: 'Please correct the Errors below',
                    duration: 10000
                });
            }
        },
        async sendPhone({dispatch, commit}, data) {
            try {
                commit('setLoading', true)
                commit('hasErrors', false)
                const response = await api.sendPhone(data);
                await localStorage.setItem('user_id', response.user.id);
                window.location.href = '/reset-account'
                ElMessage.success({
                    message: 'Verification code sent successfully!',
                    duration: 10000
                });
                commit('setLoading', true)
            } catch (e) {
                commit('setLoading', false)
                commit('hasErrors', true)
                commit('setErrors', e.response)
                ElMessage.error({
                    message: 'Please correct the Errors below',
                    duration: 10000
                });
            }
        },
        async activateAccount({dispatch, commit}, data) {
            try {
                commit('authenticating', true)
                commit('hasErrors', false)
                const response = await api.activateAccount(data);
                commit('authenticating', false)
                await localStorage.setItem('user_id', response.user.id);
                window.location.href = '/verify-number'
                ElMessage.success({
                    message: 'Phone number Found successfully',
                    duration: 10000
                });
            } catch (e) {
                commit('authenticating', false)
                let status = e.response.status
                if (status === 423) {
                    ElMessage.error({
                        message: e.response.data.message,
                        duration: 10000
                    });
                    setTimeout(function () {
                        window.location.href = '/login'
                    }, 2000);
                } else if (status === 401) {
                    commit('setAuthorizationError', e.response.data.message)
                } else {
                    commit('hasErrors', true)
                    commit('setErrors', e.response)
                    ElMessage({
                        type: "error",
                        message: 'Please correct the Errors below',
                        duration: 10000
                    });
                }
            }
        },
        async reset({dispatch, commit}, data) {
            try {
                commit('authenticating', true)
                commit('hasErrors', false)
                const response = await api.reset(data);
                commit('authenticating', false)
                await localStorage.setItem('app_token', response.token);
                await localStorage.setItem('user', JSON.stringify(response.user))
                window.location.href = '/dashboard'
                ElMessage.success({
                    message: 'Password Reset Successfully!',
                    duration: 10000
                });
            } catch (e) {
                commit('authenticating', false)
                commit('hasErrors', true)
                commit('setErrors', e.response)
                ElMessage.error({
                    message: 'Please correct the Errors below',
                    duration: 10000
                });
            }
        },
        async resendOTP({dispatch}, data) {
            try {
                await api.resendOTP(data);
                ElMessage.success({
                    message: 'Verification code resent successfully',
                    duration: 10000
                });
            } catch (e) {
                ElMessage.error({
                    message: e.response.data.message,
                    duration: 10000
                });
            }
        },
        async createUser({dispatch, commit}, data) {
            try {
                commit("setLoading", true)
                commit('hasErrors', false)
                await api.createUser(data);
                commit('setDialogVisible', false)
                ElMessage.success({
                    message: "User created successfully!"
                })
                commit("setLoading", false)
            } catch (e) {
                commit('hasErrors', true)
                commit('setErrors', e.response)
                ElMessage.error({
                    message: "There was a problem adding the user. Please t"
                })
                commit("setLoading", false)
            }
        },
        async editUser({dispatch, commit}, data) {
            try {
                commit("setLoading", true)
                commit('hasErrors', false)
                await api.editUser(data)
                commit('setDialogVisible', false)
                ElMessage.success({
                    message: 'User updated successfully!'
                });
                commit("setLoading", false)
            } catch (e) {
                commit('hasErrors', true)
                commit('setErrors', e.response)
                ElMessage.error({
                    message: e.response.data.message,
                    duration: 10000
                });
                commit("setLoading", false)
            }
        },
        // Left un-caught, unlike this file's other actions - it lets
        // Users.vue's own confirm-dialog wrapper (which already has real
        // success/error ElMessage handling) see the rejection, instead
        // of swallowing it here and leaving that catch block dead.
        async removeUser({dispatch}, id) {
            await api.removeUser(id);
            dispatch('getUsers', {paginate: true});
        },
        async getUser({commit}, id) {
            try {
                const response = await api.getUser(id);
                commit('setUser', response?.data);
            } catch (e) {
                ElMessage.error(e.response.data.message);
            }
        },

        async deactivateAdminAccount({commit, dispatch}, data) {
            try {
                const response = await api.deactivateAdminAccount(data);
                dispatch('getUsers', {
                    paginate: true
                })
                ElMessage.success({
                    message: response.message,
                    duration: 10000
                });
            } catch (e) {
                ElMessage.error({
                    message: e.response.data.message,
                    duration: 10000
                });
            }
        },
        async activateAdminAccount({commit, dispatch}, data) {
            try {
                const response = await api.activateAdminAccount(data);
                dispatch('getUsers', {
                    paginate: true
                })
                ElMessage.success({
                    message: response.message,
                    duration: 10000
                });
            } catch (e) {
                ElMessage.error({
                    message: e.response.data.message,
                    duration: 10000
                });
            }
        },

        async getUserPermissions({commit}, filters) {
            try {
                commit('activateLoading', 'role/list', {root: true});
                const response = await api.getUserPermissions(filters);
                commit('setUserPermissions', response?.data);
                commit('deactivateLoading', 'role/list', {root: true});
            } catch (e) {
                commit('deactivateLoading', 'role/list', {root: true});
                ElMessage.error(e.response.data.message);
            }
        },
        async getUserRoles({commit}, filters) {
            try {
                commit('activateLoading', 'role/list', {root: true});
                const response = await api.getUserRoles(filters);
                commit('setUserRoles', response?.data);
                commit('deactivateLoading', 'role/list', {root: true});
            } catch (e) {
                commit('deactivateLoading', 'role/list', {root: true});
                ElMessage.error(e.response.data.message);
            }
        },
        async saveUserRoles({commit, dispatch}, data) {
            try {
                await api.saveUserRoles(data);
                dispatch('getUserRoles', {
                    paginate: true,
                    ...data
                });
                ElMessage.success('User roles added successfully!');
            } catch (e) {
                ElMessage.error(e.response.data.message);
            }
        },

        openDialogVisible({commit}, status) {
            commit('setDialogVisible', status);
        },

        async exportUsersReport({commit}, {filters, format}) {
            try {
                commit('setLoading', true);
                let fileName = new Date().toISOString().slice(0, 10).replaceAll("-", "_") + "_" + new Date().toLocaleTimeString();
                const response = await api.exportUsersReport({...filters, format});
                const url = window.URL.createObjectURL(new Blob([response]))
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', 'Users_Report_' + fileName + '.' + format);
                document.body.appendChild(link);
                link.click();
                commit('setLoading', false);
            } catch (e) {
                commit('setLoading', false);
                if (e.response.status === 422) {
                    ElMessage.error("Whoops! You have insufficient permissions to perform this action.");
                } else {
                    ElMessage.error(e.response.data.message);
                }
            }
        },


    }
}
